module.exports = require('./reserved-words');



//////////////////
// WEBPACK FOOTER
// ./~/reserved-words/lib/index.js
// module id = lyye
// module chunks = 144